var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWithDraw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 68,
    viewBox: "0 0 69 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4998 57.8C47.6442 57.8 58.2998 47.1444 58.2998 34C58.2998 20.8557 47.6442 10.2 34.4998 10.2C21.3554 10.2 10.6998 20.8557 10.6998 34C10.6998 47.1444 21.3554 57.8 34.4998 57.8ZM34.4998 61.2C49.5219 61.2 61.6998 49.0222 61.6998 34C61.6998 18.9779 49.5219 6.80005 34.4998 6.80005C19.4777 6.80005 7.2998 18.9779 7.2998 34C7.2998 49.0222 19.4777 61.2 34.4998 61.2Z",
    fill: "#33CCBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8395 27.3796C22.6793 26.9597 23.7004 27.3001 24.1203 28.1398L29.1769 38.2529L32.908 28.3032C33.1568 27.6397 33.7911 27.2001 34.4998 27.2001C35.2084 27.2001 35.8427 27.6397 36.0915 28.3032L39.8227 38.2529L44.8793 28.1398C45.2991 27.3001 46.3203 26.9597 47.16 27.3796C47.9998 27.7994 48.3402 28.8206 47.9203 29.6603L41.1203 43.2603C40.8179 43.8651 40.1859 44.2332 39.5107 44.1977C38.8355 44.1623 38.2454 43.7301 38.008 43.097L34.4998 33.7417L30.9915 43.097C30.7541 43.7301 30.1641 44.1623 29.4889 44.1977C28.8137 44.2332 28.1816 43.8651 27.8793 43.2603L21.0793 29.6603C20.6594 28.8206 20.9998 27.7994 21.8395 27.3796Z",
    fill: "#33CCBD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithDraw);
export default __webpack_public_path__ + "static/media/WithDraw.be9439ccc49fcb58d3e26f9559e17ab7.svg";
export { ForwardRef as ReactComponent };